var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMostActiveHosts = function SvgMostActiveHosts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ADC6FF",
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ADC6FF",
    y: 18,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ADC6FF",
    y: 36,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7D1F3",
    d: "M18 23h34v2H18zM18 5h34v2H18zM18 41h34v2H18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FA3AF",
    d: "M58 23h22v2H58zM58 5h22v2H58zM58 41h22v2H58z"
  }))));
};
export default SvgMostActiveHosts;